import React, { useEffect } from 'react';

import { useMapContext } from './context';

type GeomGeoJSONCoordinate = [
  number, // lng
  number, // lat
];

type GeomMultiPolygonGeoJSON = {
  type: 'MultiPolygon';
  coordinates: GeomGeoJSONCoordinate[][][];
};

export type GeomGeoJSON = GeomMultiPolygonGeoJSON;

const parseMultiPolygonGeoJSON = (
  maps: typeof google.maps,
  geom: GeomMultiPolygonGeoJSON,
  options?: google.maps.PolygonOptions,
): google.maps.Polygon[] => {
  return geom.coordinates.map((coordinates) => {
    const paths = coordinates.map((ring) =>
      ring.map(([lng, lat]) => {
        return new maps.LatLng(Number(lat), Number(lng));
      }),
    );
    return new maps.Polygon({ ...options, paths });
  });
};

const parseGeoJSON = (
  maps: typeof google.maps,
  geom: GeomGeoJSON,
  options?: google.maps.PolygonOptions,
): google.maps.Polygon[] => {
  switch (geom.type) {
    case 'MultiPolygon':
      return parseMultiPolygonGeoJSON(maps, geom, options);
    default:
      return [];
  }
};

export const Geom: React.FC<{
  geom: GeomGeoJSON;
  options?: google.maps.PolygonOptions;
}> = ({ geom, options }) => {
  const { map, maps } = useMapContext();
  if (!maps || !map) throw new Error('No map found');

  useEffect(() => {
    const polygons = parseGeoJSON(maps, geom, options);
    for (const polygon of polygons) {
      polygon.setMap(map);
    }
    return () => {
      for (const polygon of polygons) {
        polygon.setMap(null);
      }
    };
  }, [geom, map, options, maps]);

  return null;
};
